import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Form, DropdownProps, InputProps, Icon, Segment } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";

import TableApp, { ITableAppRender } from "../../components/TableApp";

import errors from "../../Utils/ExtractErrors";
import TopSalesRepository, { ITopSales, ITopSalesParams } from "../../Repositories/TopSales";
import numberFormat from "../../Utils/NumberFormat";
import { CSVLink } from "react-csv";
import CustomLoader from "../../components/CustomLoader";
import { GetUser } from "../../services/auth";

const Prevision: React.FC = () => {

    const date = new Date();
    const [list, setList] = useState<ITopSales[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<ITopSalesParams>({ year: date.getFullYear().toString(), month: (date.getMonth() + 1).toString(), min: 1, max: 5000, status: "0,1", tipo: "0,1" });
    const { role } = GetUser();

    const optionsMonth = [
        { key: "1", text: "JANEIRO", value: "1" },
        { key: "2", text: "FEVEREIRO", value: "2" },
        { key: "3", text: "MARÇO", value: "3" },
        { key: "4", text: "ABRIL", value: "4" },
        { key: "5", text: "MAIO", value: "5" },
        { key: "6", text: "JUNHO", value: "6" },
        { key: "7", text: "JULHO", value: "7" },
        { key: "8", text: "AGOSTO", value: "8" },
        { key: "9", text: "SETEMBRO", value: "9" },
        { key: "10", text: "OUTUBRO", value: "10" },
        { key: "11", text: "NOVEMBRO", value: "11" },
        { key: "12", text: "DEZEMBRO", value: "12" }
    ];

    const optionsYear = [
        { key: "1", text: "2020", value: "2020" },
        { key: "2", text: "2021", value: "2021" },
        { key: "3", text: "2022", value: "2022" },
        { key: "4", text: "2023", value: "2023" },
        { key: "5", text: "2024", value: "2024" },
        { key: "6", text: "2025", value: "2025" },
        { key: "7", text: "2026", value: "2026" },
    ];

    const optionsStatus = [
        { key: "1", text: "Todos", value: "0,1" },
        { key: "2", text: "Ativo", value: "1" },
        { key: "3", text: "Inativo", value: "0" }
    ];

    const optionsTipo = [
        { key: "0", text: "Novo", value: "0" },
        { key: "1", text: "Acerto", value: "1" },
        { key: "2", text: "Ambos", value: "0,1" }
    ];

    const load = async () => {
        if (state.min <= state.max) {
            try {
                setLoading(true);
                const response = await TopSalesRepository.TopSales({
                    year: state.year,
                    month: state.month,
                    min: state.min,
                    max: state.max,
                    status: state.status,
                    tipo: state.tipo
                });

                setList(response);
            } catch (err) {
                if (err.response.status === 401) {
                    window.location.href = "/";
                }

                const error = errors.getAllErrors(err.response.data);

                if (error !== undefined)
                    toast(error, { position: "top-center", type: "error" });
            }
            setLoading(false);
        }
        else {
            toast("❌ O Valor mínimo não pode ser maior que o valor máximo.", { position: "top-center", type: "error" });
        }
    };

    useEffect(() => { load() }, []);

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const onChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: InputProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const setButtonContact = (revendedor: string, valorVendido: number, celular: string) => {
        const linkBase = "https://api.whatsapp.com/send?phone=55";
        const contatoRevendedor = celular.replace("(", "").replace(")", "").replace("-", "") + "&text=";        
        const predefinirMes = state.month < "10" ? "0" : "";
        const mesVenda = predefinirMes + state.month + "/" + state.year;

        const mensagem =
            "Olá *" + revendedor + "*, Sou " + GetUser().nome.split(" ")[0] + ", da *Poder Feminino*, " +
            "e estou entrando em contato com você para te parabenizar por suas vendas em " + mesVenda +
            "!!, Estamos com um incentivo todo mês de acertos acima de *R$ 900,00* em vendas, e como você chegou próximo, estou aqui para " +
            "te mostrar o incentivo do seu próximo acerto! " +
            "Boas vendas, muito sucesso e conte comigo para o que precisar!";

        const mensagem900 =
            "Olá *" + revendedor + "*, Sou " + GetUser().nome.split(" ")[0] + ", da *Poder Feminino*, " +
            "e estou entrando em contato com você para te parabenizar por suas excelentes vendas em " + mesVenda +
            "!!, Com suas vendas, você ganhou o incentivo referente a este acerto, e será entregue por sua Representante. " +
            "Boas vendas, muito sucesso e conte comigo para o que precisar!";

        if (valorVendido >= 500 && valorVendido <= 899) {
            return <Button
                size="small"
                as="a"
                color="blue"
                icon="whatsapp"
                target="_blank"
                href={linkBase + contatoRevendedor + mensagem}
            />
        }
        if (valorVendido >= 900) {
            return <Button
                size="small"
                as="a"
                color="green"
                icon="whatsapp"
                target="_blank"
                href={linkBase + contatoRevendedor + mensagem900}
            />
        }
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Kit",
            content: (x: ITopSales) => x.numero,
            textAlign: "center",
            width: 1
        },
        {
            header: "Status",
            content: (x: ITopSales) => (x.status === 0 ? "Inativo" : "Ativo"),
            textAlign: "left",
            width: 1
        },
        {
            header: "Representante",
            content: (x: ITopSales) => x.representante,
            textAlign: "left",
            width: 4
        },
        {
            header: "Revendedor",
            content: (x: ITopSales) => x.revendedor,
            textAlign: "left",
            width: 3
        },
        {
            header: "Cidade",
            content: (x: ITopSales) => x.cidade,
            textAlign: "left",
            width: 2
        },
        {
            header: "Contato",
            content: (x: ITopSales) => x.celular,
            textAlign: "left",
            width: 2
        },
        {
            header: "R$ Vendido",
            content: (x: ITopSales) => numberFormat.Currency((x.valorVendido)),
            textAlign: "center",
            width: 2
        },
        {
            header: "",
            content: (x: ITopSales) => role === "Admin" ? setButtonContact(x.revendedor, x.valorVendido, x.celular) : "",
            textAlign: "center",
            width: 1
        }
    ];

    const headers = [
        "KIT", "REPRESENTANTE", "REVENDEDOR", "STATUS", "CIDADE", "VENDA BRUTA", "CONTATO"
    ]
    const csvReport = {
        data: list.map(row => Object.values(row)),
        headers: headers,
        filename: 'Ranking de vendas.csv'
    };
    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content={`Ranking de Vendas`} icon="numbered list" />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="month"
                                                placeholder="Selecione o mês"
                                                label="Mês"
                                                options={optionsMonth}
                                                value={state.month}
                                                onChange={onDropdownChange}

                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="year"
                                                placeholder="Selecione o ano"
                                                label="Ano"
                                                options={optionsYear}
                                                value={state.year}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="status"
                                                placeholder="Selecione o status"
                                                label="Status Revendedor"
                                                options={optionsStatus}
                                                value={state.status}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="tipo"
                                                placeholder="Selecione o tipo"
                                                label="Tipo do kit"
                                                options={optionsTipo}
                                                value={state.tipo}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Input
                                                fluid
                                                label="Valor mínimo"
                                                labelPosition="left"
                                                name="min"
                                                placeholder="Valor mínimo"
                                                value={state.min}
                                                onChange={onChange}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Input
                                                fluid
                                                label="Valor máximo"
                                                labelPosition="left"
                                                name="max"
                                                placeholder="Valor máximo"
                                                value={state.max}
                                                onChange={onChange}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width="15">
                                <Button
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Pesquisar"
                                    onClick={load}
                                />
                            </Grid.Column>
                            <Grid.Column width="1">
                                <CSVLink
                                    separator={";"}
                                    {...csvReport}
                                >
                                    <Button fluid color="green" icon>
                                        <Icon name="download" />
                                    </Button>
                                </CSVLink>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default Prevision;
